import { jsx as _jsx } from "react/jsx-runtime";
import { useTrackRemovedAnAssetFromCollectionForm } from "@air/analytics";
import { ShortUrl } from "@air/api";
import { ConfirmationModal } from "@air/component-confirmation-modal";
import { useShortIdContext } from "@air/provider-short-id";
import { useToasts } from "@air/provider-toast";
import { removeUploadsAction, uploadArraySelector } from "@air/redux-uploader";
import pluralize from "pluralize";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteBoardCollectionClipsAction } from "~/store/boardCollection/actions";
import { boardCollectionFormSelector, boardCollectionSessionIdSelector } from "~/store/boardCollection/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
import { DeleteAssetsWarning } from "../Modals/DeleteBoards/DeleteAssetsWarning";
export const BoardCollectionDeleteClipsModal = (param)=>{
    let { clips, onClose } = param;
    const store = useAirStore();
    const { trackRemovedAnAssetFromCollectionForm } = useTrackRemovedAnAssetFromCollectionForm();
    const dispatch = useDispatch();
    const [deleting, setDeleting] = useState(false);
    const { showToast } = useToasts();
    const { shortId } = useShortIdContext();
    const deleteClips = async ()=>{
        try {
            setDeleting(true);
            const uploads = uploadArraySelector(store.getState());
            const uploadIds = uploads.filter((param)=>{
                let { clipId } = param;
                return clips.find((param)=>{
                    let { id } = param;
                    return id === clipId;
                });
            }).map((param)=>{
                let { id } = param;
                return id;
            });
            const sessionId = boardCollectionSessionIdSelector(store.getState());
            const form = boardCollectionFormSelector(store.getState());
            if (!sessionId) {
                return;
            }
            dispatch(removeUploadsAction({
                uploadIds
            }));
            dispatch(deleteBoardCollectionClipsAction({
                clipIds: clips.map((c)=>c.id)
            }));
            await ShortUrl.deleteFormSessionAssets({
                assetIds: clips.map((clip)=>clip.assetId),
                formId: form.id,
                sessionId,
                shortId
            });
            trackRemovedAnAssetFromCollectionForm({
                numberOfAssets: clips === null || clips === void 0 ? void 0 : clips.length
            });
            onClose();
        } catch (_error) {
            showToast("There was an error. Please try again later.");
            setDeleting(false);
        }
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        id: "delete-board-collection-clips",
        isOpen: true,
        onDismiss: onClose,
        title: "Delete ".concat(pluralize("item", clips.length, true), "?"),
        description: "".concat(pluralize("This", clips.length), " ").concat(pluralize("item", clips.length), " will be removed from your content submission unless you re-upload ").concat(clips.length > 1 ? "them" : "it", "."),
        onConfirm: deleteClips,
        ctaPrimaryText: deleting ? "Deleting…" : "Delete",
        ctaSecondaryText: "Cancel",
        isDangerous: true,
        isLoading: deleting,
        children: /*#__PURE__*/ _jsx("div", {
            className: "mt-4",
            children: /*#__PURE__*/ _jsx(DeleteAssetsWarning, {})
        })
    });
};
